
<template>
  <div
      :class="'is-' + size"
      :style="{ gridTemplateColumns: 'repeat(' + (columns || options.length) + ', minmax(0, 1fr))' }"
      class="lp-option-tiles">
    <button
        v-tooltip="option.tooltip || ''"
        v-for="option in options"
        :key="String(option.value)"
        :class="{ 'is-active': value !== null && value === option.value }"
        :disabled="option.disabled"
        type="button"
        class="lp-option-tiles__tile"
        @click="select(option)">
      <span class="lp-option-tiles__preview">
        <slot
            :option="option"
            name="preview">
          <img
              v-if="option.image"
              :src="option.image"
              alt="">
          <icon
              v-else-if="option.icon"
              :name="option.icon"/>
        </slot>
      </span>
      <span class="lp-option-tiles__label">{{ option.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name:  'OptionTiles',
  props: {
    options: { type: Array, required: true },
    value:   { type: [String, Number, Boolean], default: null },
    columns: { type: Number, default: 0 },
    size:    { type: String, default: 'lg' },
  },
  methods: {
    select(option) {
      if (option.disabled) {
        return;
      }
      this.$emit('click', option);
      this.$emit('input', option.value);
      this.$emit('change', option.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-option-tiles {
  display: grid;
  gap: 8px;
}

.lp-option-tiles__tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 6px 6px 8px;
  border: 1px solid $lp-line;
  border-radius: $lp-radius-tile;
  background: $white;
  font-family: $lp-sans;
  color: $lp-ink-2;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: #C9CDD4;
  }

  &.is-active {
    border-color: $lp-accent;
    box-shadow: 0 0 0 1px $lp-accent;
    background: $lp-accent-soft;
    color: $lp-accent;

    .lp-option-tiles__preview {
      background: $white;
    }
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
}

.lp-option-tiles__preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  overflow: hidden;
  border-radius: $lp-radius-control;
  background: $lp-fill;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.lp-option-tiles__label {
  max-width: 100%;
  overflow: hidden;
  font-size: $lp-fs-control;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.is-sm {
  .lp-option-tiles__tile {
    gap: 2px;
    padding: 8px 4px;
    border-color: transparent;
    background: $lp-fill;

    &.is-active {
      border-color: $lp-accent;
      background: $lp-accent-soft;
    }
  }

  .lp-option-tiles__preview {
    height: 20px;
    background: transparent;
  }

  .lp-option-tiles__label {
    font-size: $lp-fs-label;
  }
}
</style>
